import React from 'react';
import '../static/styles/divider.scss';

interface Props {
	borderBottom?: string
}

interface State {
}

class Divider extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
	}

	render() {
		return (
			<div className="ins-divider"
			     style={{borderBottom: this.props.borderBottom ? this.props.borderBottom : "1px solid #E3E6EB"}}/>
		)
	}
}

export default Divider;
